import { z } from 'zod'

const envSchema = z.object({
  VITE_BUCKET_URL: z.url(),
  VITE_API_URL: z.url(),
VITE_SENTRY_DSN: z.string().optional(),
})

const _env = envSchema.safeParse(import.meta.env)

if (!_env.success) {
  const formattedErrors = _env.error.issues
    .map((issue) => `  - ${issue.path.join('.')}: ${issue.message}`)
    .join('\n')

  console.error(`❌ Variáveis de ambiente inválidas:\n${formattedErrors}`)
  throw new Error('Variáveis de ambiente inválidas. Verifique o console para mais detalhes.')
}

export const env = {
  bucketUrl: _env.data.VITE_BUCKET_URL,
  apiUrl: _env.data.VITE_API_URL,
sentryDsn: _env.data.VITE_SENTRY_DSN,
} as const
